module.exports = __webpack_public_path__ + "at.no1.14ccab93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/at.no1.jpg
// module id = U/Fn
// module chunks = 0